import PropTypes from 'prop-types';
import React from 'react';


const Breadcrumb = ({ items }) => (
  <div className="landing-page__breadcrumb">
    <ul className="landing-page__breadcrumb__list">
      { items.map((item, i) => ((i + 1 === items.length)
        ? (
          <li key={ `landing-page__breadcrumb__list__item-${i}` } className="landing-page__breadcrumb__list__item">
            {i !== 0 ? <span className="landing-page__breadcrumb__list__item__arrow hundredicons-arrow-right-filled" /> : null}
            <span className="landing-page__breadcrumb__list__item__link__actual">
              {item.text}
            </span>
          </li>
        ) : (
          <li key={ `landing-page__breadcrumb__list__item-${i}` } className="landing-page__breadcrumb__list__item">
            {i !== 0 ? <span className="landing-page__breadcrumb__list__item__arrow hundredicons-arrow-right-filled" /> : null}
            <a className="landing-page__breadcrumb__list__item__link" href={ item.url.endsWith('/') ? item.url : `${item.url}/` } title={ item.title }>
              {item.text}
            </a>
          </li>
        ))) }
    </ul>
  </div>
);

Breadcrumb.defaultProps = {
  items: [],
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
};

export default Breadcrumb;
